import { useCallback, useState } from "preact/hooks";

import { Hourglass } from "@attaditya/iconoir-preact";
import { SuggestionButton } from "@components/kit/suggestion-button";
import { Button } from "@components/ui/interactive/button";
import { Input } from "@components/ui/interactive/input";
import { Container } from "@components/ui/structure/container";
import { Heading } from "@components/ui/text/heading";
import { useChat } from "@contexts/chat";
import { useUser } from "@contexts/user";
import { useClasses } from "@styles";

export function NewChatView() {
  const { ready, authenticated } = useUser();
  const { newChat } = useChat();
  const [loading, setLoading] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>("");

  const suggestions = [
    "Fastest Delivery in Last 24 Hours",
    "Top performers in Last 7 Days",
    "Delivery Performance by Region",
  ];

  const submit = useCallback(async () => {
    if (!inputValue) return;
    setLoading(true);
    const [uuid, error] = await newChat(inputValue);
    console.log(uuid, error);

    if (uuid === null) {
      alert(error);
      setLoading(false);
      return;
    }

    const key = [
      "apiCache::",
      (window as any).apiBaseUrl,
      ":/chat:GET:undefined",
    ].join("");

    localStorage.removeItem(key);
    window.location.href = `/report/${uuid}`;
  }, [inputValue]);

  if (ready && !authenticated) {
    window.location.href = "/auth";

    return null;
  }

  return (<>
    <Container className={useClasses('new-chat')}>
      {loading && <Container
        className={useClasses('new-chat-loading')
      }>
        <Hourglass
          className={useClasses('new-chat-loading-icon')}
        />
      </Container>}

      {!loading && (<>
        <Heading
          size="medium"
          className={useClasses('new-chat-heading')}
        >
          What report are we building today?
        </Heading>

        <Container className={useClasses('new-chat-form')}>
          <Input
            autoFocus={true}
            onInput={(value) => setInputValue(value)}
            defaultValue={inputValue}
            containerClassName={useClasses('new-chat-input-container')}
            className={useClasses('new-chat-input')}
            placeholder="What are you analyzing today?"
            onEnter={submit}
            rightChildren={<Button
              disabled={!inputValue}
              icon="ArrowRightRegular"
              onClick={submit}
            />}
          />

          <Container className={useClasses('new-chat-suggestions')}>
            {suggestions.map((suggestion) => (<SuggestionButton
              key={suggestion}
              onClick={() => setInputValue(suggestion)}
            >
              {suggestion}
            </SuggestionButton>))}
          </Container>
        </Container>
      </>)}
    </Container>
  </>);
}

